/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import '../vendors/owl.carousel.min';
import '../vendors/masonry.min';
import '../vendors/custom-inputs';
import './ajax-blog-filter';
import '../vendors/isotope-pkgd.min';
import '../vendors/event-calender';
import '../vendors/gsap.min';
import '../vendors/MorphSVGPlugin';
const categotysTerms = jQuery( '#dropdown-category-select' ).CustomSelect();

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

jQuery( document ).ready( function() {
	 function addClassToParent() {
		// Get all elements with the class "owl-carousel"
		jQuery( '.owl-carousel' ).each( function() {
			// Get the parent section of the div
			const parentSection = jQuery( this ).closest( 'section' );

			// Check if the parent section is found
			if ( parentSection.length > 0 ) {
				// Add the class "no-overflow" to the parent section
				parentSection.addClass( 'no-overflow' );
			}
		} );
	}

	// Call the function
	addClassToParent();

	jQuery( '.openVideo' ).magnificPopup( {
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: true,

	} );

	const e = jQuery( '.popup-btn' ).attr( 'href' );
	jQuery( '.popup-btn' ).magnificPopup( {
		items: {
			src: '<iframe src="' + e + '?autoplay=1&rel=0&frameborder="0"" title="YouTube video player" frameborder="0" allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
			type: 'iframe',
		},
		closeBtnInside: ! 1,
		removalDelay: 300,
		mainClass: 'video-popup-my-custom-class',
	} );

	const topicSelect = jQuery( '#dropdown-topic-select' ).CustomSelect();
	const typeSelect = jQuery( '#dropdown-type-select' ).CustomSelect();
	jQuery( '.calendar__row' ).EventCalender();
	const windowWidth = jQuery( window ).width();

	jQuery( document ).on( 'click', '.select-dropdown__checkbox', function() {
		ajaxFilterEvent();
	} );
	jQuery( document ).on( 'keyup', '.resource-ajaxfilter-element', function( e ) {
		if ( e.key === 'Enter' || e.keyCode === 13 ) {
			ajaxFilterEvent();
		}
	} );
	jQuery( '.mobile-search-button' ).on( 'click', function() {
		// Trigger a click on .mobile-submit
		jQuery( '#searchsubmit' ).click();
		ajaxFilterEvent();
	} );
	jQuery( document ).on( 'keyup', '.topic-select-select-item', function( e ) {
		if ( e.key === 'Enter' || e.keyCode === 13 ) {
			ajaxFilterEvent();
		}
	} );
	jQuery( document ).on( 'keyup', '.type-select-select-item', function( e ) {
		if ( e.key === 'Enter' || e.keyCode === 13 ) {
			ajaxFilterEvent();
		}
	} );
	function ajaxFilterEvent() {
		setTimeout( () => {
			const topic = topicSelect.getValue();
			const type = typeSelect.getValue();
			const layout = jQuery( '#event-ajax-response' ).attr( 'data-view' );
			const search = jQuery( '.resource-ajaxfilter-element' ).val();
			const items = {
				topic,
				type,
				layout,
				search,
			};
			if ( history.pushState ) {
				const oldurl = window.location.protocol + '//' + window.location.host + window.location.pathname;

				let newurl = '';
				let count = 0;
				for ( const key in items ) {
					const element = items[ key ];

					if ( element !== '' || typeof element !== 'undefined' ) {
						if ( count == 0 ) {
							newurl = oldurl + '?';
							newurl += key + '=' + element;
						} else {
							newurl += '&' + key + '=' + element;
						}
					}
					count++;
				}

				window.history.pushState( { path: newurl }, '', newurl );
				jQuery( '.event-btns-inner' ).find( 'a.first' ).attr( 'href', newurl.replace( 'list', 'calendar' ) );
				jQuery( '.event-btns-inner' ).find( 'a.second' ).attr( 'href', newurl.replace( 'calendar', 'list' ) );
			}
			jQuery( '.lds-roller' ).show();
			jQuery.ajax( {
				url: localVars.ajax_url,
				type: 'post',
				data: {
					action: 'events_filter',
					topic,
					type,
					layout,
					search,
				},
				success( response ) {
					if ( response === '' ) {
						// If the response is empty, display "No events found" message
						const noEventsMessage = '<div class="s-72"></div><div id="no-events-found">Sorry, no events found, please try a different search.</div>';
						jQuery( '#event-ajax-response' ).html( noEventsMessage );
					} else {
						// If there is a response, hide the extra div, update the content and perform other actions
						jQuery( '#no-events-found' ).remove(); // Remove the "No events found" message if it was previously displayed
						jQuery( '#event-ajax-response' ).html( response );
						jQuery( '.calendar__row' ).EventCalender();
					}

					jQuery( '.lds-roller' ).hide();
				},

			} );
		}, 100 );
	}

	jQuery.noConflict();

	jQuery.noConflict();
	jQuery( document ).on( 'click', '.reset-filters', function() {
		topicSelect.setValue( '' );
		typeSelect.setValue( '' );
		jQuery( '.resource-ajaxfilter-element' ).val( '' );
		ajaxFilterEvent();
	} );
	/***** Custom Select *****/

	// Check the screen width when the page loads
	checkScreenWidth();

	// Check the screen width whenever the window is resized
	jQuery( window ).resize( function() {
		checkScreenWidth();
	} );
	jQuery( document ).on( 'click', '.cancel-search-btn', function() {
		jQuery( '.keyword' ).val( '' );
	} );
	// Function to check screen width and update the select box accordingly
	function checkScreenWidth() {
		const screenWidth = jQuery( window ).width();
		const customSelect = jQuery( '.issues__select' );

		if ( screenWidth <= 1003 ) {
			// Hide the original filter buttons
			jQuery( '.filter-buttons' ).hide();

			// Show the custom select box
			customSelect.show();

			// Handle custom select box interactions
			customSelect.find( '.selected-option' ).click( function() {
				customSelect.find( '.options' ).toggle();
			} );

			customSelect.find( '.options li' ).click( function() {
				const selectedValue = jQuery( this ).data( 'value' );
				customSelect.find( '.selected-option span' ).text( selectedValue );
				customSelect.find( '.options' ).hide();
			} );
		} else {
			// Show the original filter buttons
			jQuery( '.filter-buttons' ).show();

			// Hide the custom select box
			customSelect.hide();
		}
	}

	/***** Custom Select *****/

	const lines = [ '.path01', '.path03', '.path05', '.path07', '.path09', '.path11', '.path13', '.path15', '.path17', '.path19', '.path21', '.path23', '.path25', '.path27', '.path29', '.path31', '.path33', '.path35', '.path37', '.path39', '.path41', '.path43', '.path45', '.path47', '.path49', '.path51', '.path53', '.path55', '.path57', '.path59', '.path61', '.path63', '.path65', '.path67', '.path69', '.path71', '.path73', '.path75', '.path77', '.path79', '.path81', '.path83', '.path85', '.path87', '.path89', '.path91', '.path93', '.path95', '.path97', '.path99', '.path101', '.path103', '.path105', '.path107', '.path109', '.path111', '.path113', '.path115', '.path117', '.path119', '.path121', '.path123', '.path125', '.path127', '.path129' ];
	const waves = [ '.path02', '.path04', '.path06', '.path08', '.path10', '.path12', '.path14', '.path16', '.path18', '.path20', '.path22', '.path24', '.path26', '.path28', '.path30', '.path32', '.path34', '.path36', '.path38', '.path40', '.path42', '.path44', '.path46', '.path48', '.path50', '.path52', '.path54', '.path56', '.path58', '.path60', '.path62', '.path64', '.path66', '.path68', '.path70', '.path72', '.path74', '.path76', '.path78', '.path80', '.path82', '.path84', '.path86', '.path88', '.path90', '.path92', '.path94', '.path96', '.path98', '.path100', '.path102', '.path104', '.path106', '.path108', '.path110', '.path112', '.path114', '.path116', '.path118', '.path120', '.path122', '.path124', '.path126', '.path128', '.path130' ];
	const time = 6;
	let delay = 0;
	for ( const key in lines ) {
		const line = document.querySelector( lines[ key ] );
		const wave = document.querySelector( waves[ key ] );

		const action = gsap.timeline( { delay, repeat: 1000, yoyo: true, repeatDelay: 0 } )
			.to( line, { morphSVG: wave, duration: time, ease: 'none' } );
		delay = delay + 0.2;
	}

	// Scrolling Section Script
	// if ( jQuery( window ).width() > 747 ) {
	const sections = jQuery( '.scrolling__sections--single' );

	const observer = new IntersectionObserver( function( entries ) {
		entries.forEach( function( entry ) {
			const dataClass = jQuery( entry.target ).attr( 'id' );
			if ( entry.isIntersecting ) {
				// Add the "active" class to the corresponding section
				jQuery( ".heading-2[data-class='" + dataClass + "']" ).addClass( 'active' );
			} else {
				// Remove the "active" class from the corresponding section
				jQuery( ".heading-2[data-class='" + dataClass + "']" ).removeClass( 'active' );
			}
		} );
	}, { threshold: 0.5 } );

	sections.each( function() {
		observer.observe( this );
	} );

	jQuery( '.heading-2' ).on( 'click', function() {
		const dataClass = jQuery( this ).data( 'class' );

		// Scroll to the section
		jQuery( 'html, body' ).animate( {
			scrollTop: jQuery( '#' + dataClass ).offset().top - 160,
		}, 0 );
	} );
	// }

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.search-button' ).on( 'click', function() {
			// Trigger a click on .mobile-submit
			jQuery( '.mobile-submit' ).click();
		} );
	}

	if ( jQuery( window ).width() > 1004 ) {
		jQuery( '.mobile-search-button' ).on( 'click', function() {
			// Trigger a click on .mobile-submit
			jQuery( '#searchsubmit' ).click();
		} );
	}
	if ( jQuery( window ).width() > 1003 ) {
		let lastScrollTop = 0,
			delta = 0;

		jQuery( window ).scroll( function( event ) {
			const st = jQuery( this ).scrollTop();

			if ( Math.abs( lastScrollTop - st ) <= delta ) {
				return;
			}

			if ( st > lastScrollTop && lastScrollTop > 0 ) {
				// Add classes to header elements
				jQuery( '.header__inner, .header-search-container' ).addClass( 'nav-up' );
				jQuery( '.header__inner, .header-search-container' ).removeClass( 'nav-down' );

				// Add classes to body
				jQuery( 'body' ).addClass( 'body-nav-up' );
				jQuery( 'body' ).removeClass( 'body-nav-down' );
			} else {
				// Remove classes from header elements
				jQuery( '.header__inner, .header-search-container' ).removeClass( 'nav-up' );
				jQuery( '.header__inner, .header-search-container' ).addClass( 'nav-down' );

				// Remove classes from body
				jQuery( 'body' ).removeClass( 'body-nav-up' );
				jQuery( 'body' ).addClass( 'body-nav-down' );
			}

			lastScrollTop = st;
		} );
	}
	/**
	 * Start Search Toggle
	 */
	const categotyselect = jQuery( '#dropdown-category-select' ).CustomSelect();

	if ( jQuery( window ).width() > 1003 ) {
		jQuery( document ).on( 'click focus', '.main_search_item', function() {
			jQuery( '.header-section' ).addClass( 'open' );

			jQuery( '#search-top .keyword' ).focus( );
		} );

		jQuery( '.search-close' ).on( 'focusout', function( e ) {
			jQuery( '.header-section' ).removeClass( 'open' );
			document.activeElement.blur();
		} );

		jQuery( '.search-close' ).on( 'click keypress', function( e ) {
			if ( e.which == 13 || e.which == 1 ) {
				setTimeout( () => {
					jQuery( '.header-section' ).removeClass( 'open' );
				}, 100 );
				document.activeElement.blur();
			}
		} );
	}

	jQuery( '.event-calendar-search' ).slideUp();
	jQuery( '.event-close-icon' ).hide();

	// Add a click event handler for .event-search
	jQuery( '.event-search' ).click( function() {
		// Slide down .event-calendar-search with animation
		jQuery( '.event-calendar-search' ).slideToggle();
		jQuery( '.event-search-icon, .event-close-icon' ).toggle();
	} );

	jQuery( document ).on( 'keypress', '.faq__single--inner span', function( e ) {
		if ( e.which == 13 ) {
			jQuery( this ).click();
		}
	} );

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.top-nav-search' ).click( function() {
			jQuery( '.header-section' ).addClass( 'open' );
			setTimeout( function() {
				jQuery( '#search-top #keyword' ).focus();
			}, 100 );
		} );

		jQuery( '.search-close' ).click( function() {
			jQuery( '.header-section' ).removeClass( 'open' );
		} );
	}

	jQuery.noConflict();

	/**
	 * Calendar Script Ends Here
	 */

	jQuery( '.single__box' ).each( function() {
		// Check if the 'a' element's background-color is white (#ffffff)
		if ( jQuery( this ).find( 'a' ).css( 'background-color' ) === 'rgb(255, 255, 255)' ) {
			// Change the color of '.single__box--title' to #151515
			jQuery( this ).addClass( 'white-bg' );
		}
	} );

	if ( jQuery( window ).width() > 1003 ) {
		const $megaDropdown = jQuery( '.mega__dropdown' );

		// Add the "mega-menu-ctn" class to the parent element
		$megaDropdown.parent().addClass( 'mega-menu-ctn' );
	}
	if ( jQuery( 'gallery__images' ).length > 0 ) {
		jQuery( '.gallery__images' ).masonry( {
			itemSelector: '.gallery__images--image',
			columnWidth: '.gallery__images--image',
			gutter: 30, // Adjust the gutter width as needed
		} );
	}

	/**
	 * Toggle menu for mobile
	 */
	// accessible sub menu

	jQuery( '.menu-item-has-children > a' ).focus( function() {
		jQuery( this ).siblings( '.sub-sub-menu-item' ).addClass( 'focused' );
	  } ).blur( function() {
		jQuery( this ).siblings( '.sub-sub-menu-item' ).removeClass( 'focused' );
	  } );

	// For children
	jQuery( '.sub-sub-menu-item a' ).focus( function() {
		jQuery( this ).parents( '.sub-sub-menu-item' ).addClass( 'focused' );
	} ).blur( function() {
		jQuery( this ).parents( '.sub-sub-menu-item' ).removeClass( 'focused' );
	} );

	const body = jQuery( 'body' );
	if ( jQuery( '.page-template-template-our-school' ).length > 0 ) {
		if ( body.hasClass( 'page-template-template-our-school' ) ) {
			jQuery( 'html' ).addClass( 'scroll-behavior-normal' );
		}
	}

	jQuery( '.menu-btn' ).click( function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
		jQuery( 'header' ).removeClass( 'open' );
	} );
	jQuery.noConflict();

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon"></span>' );
		}
	} );
	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */
	jQuery( '.header-nav .submenu-icon' ).click( function() {
		const link = jQuery( this );
		const closestUl = link.closest( 'ul' );
		const parallelActiveLinks = closestUl.find( '.active' );
		const closestLi = link.closest( 'li' );
		const linkStatus = closestLi.hasClass( 'active' );
		let count = 0;

		closestUl.find( 'ul' ).slideUp( function() {
			if ( ++count === closestUl.find( 'ul' ).length ) {
				parallelActiveLinks.removeClass( 'active' );
			}
		} );

		if ( ! linkStatus ) {
			closestLi.children( 'ul' ).slideDown();
			closestLi.addClass( 'active' );
		}
	} );

	// const myElement = jQuery( '.show-content' );
	// let isToggled = false;

	// jQuery( '.show-content' ).click( function() {
	// 	if ( isToggled ) {
	// 		myElement.text( 'Show More' );
	// 	} else {
	// 		myElement.text( 'Show Less' );
	// 	}
	// 	// Toggle the flag
	// 	isToggled = ! isToggled;
	// } );

	jQuery( document ).on( 'click', '.show-content', function() {
		const state = parseInt( jQuery( this ).attr( 'data-state' ) );
		if ( state === 1 ) {
			jQuery( this ).text( 'Show More' );
			jQuery( this ).attr( 'data-state', -1 );
		} else {
			jQuery( this ).text( 'Show Less' );
			jQuery( this ).attr( 'data-state', 1 );
		}
	} );

	jQuery( document ).ready( function() {
		function startCounterAnimation( element, endValue, startPercentage ) {
			let currentValue = startPercentage * endValue;

			function updateCounter() {
				if ( currentValue < endValue ) {
					currentValue++;
					element.text( currentValue );
					jQuery( { countNum: element.text() } ).animate(
						{ countNum: currentValue },
						{
							duration: 10, // Adjust the duration as needed
							step() {
								element.text( Math.floor( this.countNum ) );
							},
							complete: updateCounter,
						}
					);
				}
			}

			updateCounter();
		}

		function handleIntersection( entries, observer ) {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					const statsValueElement = jQuery( entry.target ).find( '.stats__value' );
					const endValue = parseInt( statsValueElement.attr( 'data-number' ) );
					const startPercentage = 0.75; // Adjust the starting point here (75%)
					startCounterAnimation( statsValueElement, endValue, startPercentage );

					observer.unobserve( entry.target );
				}
			} );
		}

		const observer = new IntersectionObserver( handleIntersection, { threshold: 0.25 } );

		jQuery( '.stats__item' ).each( function() {
			observer.observe( this );
		} );
	} );

	jQuery( '.popup-btn' ).magnificPopup( {
		// disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: true,
		overflowY: 'hidden',
	} );

	jQuery.noConflict();

	/**
	 * Read More
	 *
	 */

	if ( jQuery( window ).width() < 1004 ) {
		jQuery( '.team-teaser .team-members' ).owlCarousel( {
			loop: false,
			nav: false,
			dots: false,
			// autoWidth: true,
			responsive: {
				0: {
					items: 2,
					margin: 10,
					autoWidth: false,
				},
				600: {
					items: 2,
					margin: 10,
				},
				748: {
					items: 4,
					margin: 20,
				},
				1000: {
					margin: 30,
					items: 5,
				},
			},
		} );
	}

	/***** Issues Filter *****/

	// // quick search regex
	let qsRegex;
	let buttonFilter;

	// init Isotope
	const $grid = jQuery( '.issues__boxes' ).isotope( {
		itemSelector: '.issues__boxes--single',
		layoutMode: 'masonry',
		masonry: {
			columnWidth: '.issues__boxes--single',
			gutter: 30, // Set the gutter width to 30px
		},
		filter() {
			const $this = jQuery( this );
			const searchResult = qsRegex ? $this.text().match( qsRegex ) : true;
			// console.log( searchResult );
			const buttonResult = buttonFilter ? $this.is( buttonFilter ) : true;
			// console.log( 'button', buttonResult );
			return searchResult && buttonResult;
		},
	} );

	jQuery( '#filters' ).on( 'click', 'button', function() {
		buttonFilter = jQuery( this ).attr( 'data-filter' );
		$grid.isotope();
	} );
	jQuery( '#issues__select' ).on( 'click', 'ul li', function() {
		buttonFilter = jQuery( this ).attr( 'data-filter' );
		$grid.isotope();
	} );
	// use value of search field to filter
	var $quicksearch = jQuery( '#quicksearch' ).keyup( debounce( function() {
		qsRegex = new RegExp( $quicksearch.val(), 'gi' );
		$grid.isotope();
	} ) );

	// change is-checked class on buttons
	jQuery( '.filter-buttons--inner' ).each( function( i, buttonGroup ) {
		const $buttonGroup = jQuery( buttonGroup );
		$buttonGroup.on( 'click', 'button', function() {
			$buttonGroup.find( '.is-checked' ).removeClass( 'is-checked' );
			jQuery( this ).addClass( 'is-checked' );
		} );
	} );
	jQuery.noConflict();
	// debounce so filtering doesn't happen every millisecond
	function debounce( fn, threshold ) {
		let timeout;
		threshold = threshold || 100;
		return function debounced() {
			clearTimeout( timeout );
			const args = arguments;
			const _this = this;
			function delayed() {
				fn.apply( _this, args );
			}
			timeout = setTimeout( delayed, threshold );
		};
	}

	jQuery.noConflict();

	if ( jQuery( window ).width() < 748 ) {
		autosize();
		function autosize() {
			const text = jQuery( '.textarea' );

			text.each( function() {
				jQuery( this ).attr( 'rows', 1 );
				resize( jQuery( this ) );
			} );

			text.on( 'input', function() {
				resize( jQuery( this ) );
			} );

			function resize( $text ) {
				$text.css( 'height', 'auto' );
				$text.css( 'height', $text[ 0 ].scrollHeight + 'px' );
			}
		}
	}

	jQuery.noConflict();
	if ( jQuery( '.openVideo' ).length > 0 ) {
	 // Get the video element
		const video = jQuery( '.openVideo video' )[ 0 ]; // Use [0] to access the DOM element

		// Play the video
		video.play();

		// Function to restart the video after 15 seconds
		function restartVideo() {
		// Set the current time of the video to 0 (start)
			video.currentTime = 0;
			// Play the video again
			video.play();
		}

		// Set a timer to restart the video after 15 seconds
		setTimeout( restartVideo, 15000 ); // 15 seconds in milliseconds
	}
	jQuery.noConflict();

	/***** Issues Filter *****/

	if ( jQuery( '.info__boxes' ).length > 0 ) {
	 let colorPanelParent = jQuery( '.info__boxes' ),
			colorPanels = colorPanelParent.find( '.single__box a' ),
			numColorPanels = colorPanels.length,
			colorIndex = 0;

		function colorChangeTimer() {
			setTimeout( function() {
				const _panelsToChange = generateRandomPanelIndices( numColorPanels );
				colorsToChange( _panelsToChange );
				colorChangeTimer();
			}, 5000 );
		}

		function generateRandomPanelIndices( max ) {
			const indices = [];
			while ( indices.length < 1 ) {
				const randomIndex = Math.floor( Math.random() * max );
				if ( ! indices.includes( randomIndex ) ) {
					indices.push( randomIndex );
				}
			}
			return indices;
		}

		function colorsToChange( indices ) {
			const colors = [ '#0068A6', '#D82C20', '#ffffff' ];
			indices.forEach( ( index, i ) => {
				const color = colors[ ( colorIndex + i ) % colors.length ];
				const $colorPanel = jQuery( colorPanels[ index ] );

				// Add CSS transition property
				$colorPanel.css( {
					'background-color': color,
					transition: 'background-color 1s ease-in-out',
				} );

				if ( color === '#ffffff' ) {
					$colorPanel.parent().addClass( 'white-bg' );
				} else {
					$colorPanel.parent().removeClass( 'white-bg' );
				}
			} );
			colorIndex = ( colorIndex + 1 ) % colors.length;
		}

		function changeColorsOnLoad() {
			for ( let i = 0; i < numColorPanels; i += 3 ) {
				const indices = [ i, i + 1, i + 2 ].filter( ( index ) => index < numColorPanels );
				colorsToChange( indices );
			}
		}

		setTimeout( function() {
			colorChangeTimer();
			changeColorsOnLoad();
		}, 5000 );
	}
} );
if ( jQuery( window ).width() < 748 ) {
	jQuery( document ).ready( function() {
		const membershipBoxCount = jQuery( '.membership-box' ).length;

		if ( membershipBoxCount === 2 ) {
			jQuery( '.hero__membership .hero__inner' ).css( 'padding-bottom', '227px' );
			jQuery( '.hero__membership--boxes' ).css( 'margin-top', '-185px' );
		} else if ( membershipBoxCount === 1 ) {
			jQuery( '.hero__membership .hero__inner' ).css( 'padding-bottom', '105px' );
			jQuery( '.hero__membership--boxes' ).css( 'margin-top', '-63px' );
		}
	} );
}

jQuery( document ).mouseup( function( e ) {
	const container = jQuery( '.header' );

	// if the target of the click isn't the container nor a descendant of the container
	if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
		container.removeClass( 'open' );
	}
} );
jQuery( document ).mouseup( function( e ) {
	const container = jQuery( '.select-dropdown__button' );

	// if the target of the click isn't the container nor a descendant of the container
	if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
		container.removeClass( 'is-button-opened' );
	}
} );

jQuery( document ).mouseup( function( e ) {
	const container = jQuery( '.select-dropdown__button' );

	// if the target of the click isn't the container nor a descendant of the container
	if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
		container.removeClass( 'is-button-opened' );
	}
} );

jQuery( document ).mouseup( function( e ) {
	const container = jQuery( '.event__tooltip' );

	// if the target of the click isn't the container nor a descendant of the container
	if ( ! container.is( e.target ) && container.has( e.target ).length === 0 ) {
		container.hide( );
	}
} );

